import { GeneralModel } from "./general.model";

export class Role extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/role.model.ts